import React from "react";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import MainMenu from "../components/MainMenu";
import { Mixpanel } from "../utils/Mixpanel";
import { useEffect } from "react";


const NewUser = () => {
    const navigate = useNavigate();
    const [mobileTopbarActive] = useState(false);

    const goToNetworkSite = () => {
        window.location.href = process.env.REACT_APP_NETWORK_SITE + "/search";
    }

    const createProvider = () => {
        window.location.href = process.env.REACT_APP_NETWORK_SITE + "/company/create-profile";
    }

    const layoutContainerClassName = classNames(
        "layout-wrapper ",
        "pages-body",
        "login-page",
        "flex",
        "flex-column",
        "layout-menu-cyan layout-topbar-cyan",
        {
            "layout-topbar-mobile-active": mobileTopbarActive,
            "p-input-outlined": "outlined"
        }
    );

    useEffect(() => {
        Mixpanel.track("UI ID - Welcome page view");
    }, []);

    return (
        <div className={layoutContainerClassName}>
            <MainMenu />
            <div className="align-self-center mt-auto mb-auto">
                <div className="pages-panel card flex flex-column">
                    <div className="pages-header mb-4 px-3 py-1">
                        <h2>Welcome to Wallist!</h2>
                    </div>
                    <div className="text-xl mb-4">Tell us where you would like to get started</div>
                    <div className="grid" style={{ maxWidth: "800px" }}>
                        <div className="col-12 md:col-6 p-5">
                            <div className="font-bold text-xl mb-2">
                                Are you looking for help?
                            </div>
                            <div className="mb-2">Find top-rated landscapers, painters, plumbers, electricians, and other professionals in your area to help you!</div>
                            <div>
                                <br />
                                <Button label="Find Service Providers" onClick={goToNetworkSite} icon="pi pi-search" />
                            </div>
                        </div>
                        <div className="col-12 md:col-6 border-top-1 border-400 md:border-top-none border-left-0 md:border-left-1 p-5">
                            <div className="font-bold text-xl mb-2">
                                Are you a business owner?
                            </div>
                            <div className="mb-2">List your business profile on Wallist for free! You can also manage your customers, create quotes, schedule jobs, send invoices, and collect payments all through Wallist!</div>
                            <div>
                                <Button label="Grow Your Business" onClick={createProvider} icon="pi pi-building" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewUser;
